import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles, Play, Eye, Loader2 } from "lucide-react";
import { api } from "../lib/api";

const TYPE_LABEL = {
  eroeffnung: "Eröffnung",
  bedarfsermittlung: "Bedarfsermittlung",
  nutzenargumentation: "Nutzenargumentation",
  einwandbehandlung: "Einwandbehandlung",
  abschluss: "Abschluss",
  empathie: "Empathie",
};

const Highlights = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/recordings");
        setItems(data);
      } catch (e) { console.warn("Highlights load failed", e); }
      finally { setLoading(false); }
    })();
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-10">
      <div className="animate-slide-up">
        <span className="label-eyebrow">Best-Practice Mitschnitte</span>
        <h1 className="font-display font-black text-3xl sm:text-5xl tracking-tight text-white mt-2">
          Lerne von den <span className="text-novatus-green">besten Calls.</span>
        </h1>
        <p className="text-novatus-text-2 mt-3 max-w-2xl">
          Trainer-geteilte Verkaufsgespräche mit KI-annotierten Highlights. Sieh dir an, was im echten Call funktioniert hat — und übernimm Formulierungen für deine eigenen Gespräche.
        </p>
      </div>

      {loading ? (
        <div className="mt-12 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-novatus-green" /></div>
      ) : items.length === 0 ? (
        <div className="nv-card mt-10 p-12 text-center animate-slide-up">
          <Sparkles className="w-10 h-10 text-novatus-text-3 mx-auto mb-3" />
          <p className="text-novatus-text-2">Noch keine geteilten Mitschnitte. Sobald ein Trainer einen Call freigibt, erscheint er hier.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mt-9">
          {items.map((r, idx) => (
            <div
              key={r.id}
              className="nv-card nv-card-hover cursor-pointer overflow-hidden flex flex-col animate-slide-up"
              style={{ animationDelay: `${idx * 0.04}s` }}
              onClick={() => navigate(`/highlights/${r.id}`)}
              data-testid={`recording-card-${r.id}`}
            >
              <div className="h-1 bg-novatus-green" />
              <div className="p-6 flex-1 flex flex-col">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="text-[10px] uppercase tracking-wider font-bold px-2.5 py-1 rounded-full bg-novatus-green/15 text-novatus-green border border-novatus-green/40">
                    {r.mode === "active_call" ? "KI-Demo" : "Top-Call"}
                  </span>
                  <span className="text-[10px] uppercase tracking-wider font-semibold px-2.5 py-1 rounded-full bg-novatus-card-2 border border-novatus text-novatus-text-2">
                    Score {r.score}
                  </span>
                  {r.highlights?.length > 0 && (
                    <span className="text-[10px] uppercase tracking-wider font-semibold px-2.5 py-1 rounded-full bg-novatus-card-2 border border-novatus text-novatus-text-2">
                      {r.highlights.length} Highlights
                    </span>
                  )}
                </div>
                <h3 className="font-display font-bold text-xl text-white mt-4 leading-tight">{r.title}</h3>
                <p className="text-sm text-novatus-text-2 mt-2 leading-relaxed flex-1">{r.description}</p>
                <div className="mt-4 pt-4 border-t border-novatus flex items-center justify-between text-xs text-novatus-text-3">
                  <span>{r.scenario_title} · {r.seller_name}</span>
                  <span className="flex items-center gap-1"><Eye className="w-3 h-3" /> {r.views || 0}</span>
                </div>
                <button className="btn-ghost-green mt-4 h-10 rounded-lg flex items-center justify-center gap-2 text-sm font-semibold" data-testid={`open-recording-${r.id}`}>
                  <Play className="w-4 h-4" fill="currentColor" /> Mitschnitt ansehen
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Highlights;
